import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface OrgChartNodeDetailsData {
  title: string;
  subtitle?: string;
  photo?: string;
  fields: Record<string, any>;
}

@Component({
  selector: 'app-org-chart-node-details-dialog',
  templateUrl: './org-chart-node-details-dialog.component.html',
  styleUrls: ['./org-chart-node-details-dialog.component.scss'],
})
export class OrgChartNodeDetailsDialogComponent {

  readonly entries: { label: string, value: any }[];

  constructor(@Inject(MAT_DIALOG_DATA) public data: OrgChartNodeDetailsData) {
    this.entries = Object.entries(data.fields ?? {})
      .filter(([, value]) => value !== null && value !== undefined && value !== '')
      .map(([label, value]) => ({ label, value: typeof value === 'boolean' ? (value ? 'Yes' : 'No') : value }));
  }
}
